import { variant, onTerms } from 'variant';
import type { GVariantOf } from 'variant';

export const InputState = variant(
  onTerms(({ T: _T }) => ({
    NotSubmitted: (value?: typeof _T) => ({ value }),
    Submitted: (value: typeof _T) => ({ value }),
  }))
);

export type InputState<T> = GVariantOf<typeof InputState, undefined, { T: T }>;
